import { useState, useEffect } from 'react';
import { workspaceNavigationExpanded } from './workspaceNavigationExpanded';

export const useWorkspaceNavigationExpanded: () => [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
] = () => {
  const [
    isWorkspaceNavigationExpanded,
    setWorkspaceNavigationExpanded,
  ] = useState<boolean>(true);

  useEffect(() => {
    workspaceNavigationExpanded.setValue(isWorkspaceNavigationExpanded);
  }, [isWorkspaceNavigationExpanded]);

  return [isWorkspaceNavigationExpanded, setWorkspaceNavigationExpanded];
};
